import React from 'react';
import PropTypes from 'prop-types';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import fr from 'facet-rest';
import ContentWithContext from 'Views/Page/Content/Modal/Layouts/WizardStepLayout/Content';
import { BaseWizardStepOverride } from 'Views/Page/Content/Templates/BaseWizardStepOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import TrustRevocabilityWarning
  from './TrustRevocabilityWarning';

const metaOverrideSet = fr.metaOverride({ base: BaseWizardStepOverride })
  .nameOverride('trustRevocabilityWarning', {
    _component: () => TrustRevocabilityWarning,
  }, overrideReadOnly)
  .nameOverride('trustName', {
    _customHelperProps: {
      helperText: 'Only enter the name of the trust without the date or trustee information. Example "John Smith Revocable Trust".',
      noWrap: false,
    },
  })
  .nameOverride('trustRevocability', {
    _customHelperProps: {
      helperText: 'A revocable trust allows the creator to make changes during their lifetime.\nAn irrevocable trust cannot be altered or revoked once created. Currently, Facet only supports revocable trusts.',
      noWrap: false,
    },
  });

const AccountOpeningTrustInformation = ({ resource }) => {
  const [isRevocableTrust, setIsRevocableTrust] = React.useState(resource.attr('trustRevocability') === 'REVOCABLE');

  const onChange = (attr, value) => {
    if (attr !== 'trustRevocability') {
      return;
    }

    if (value === 'REVOCABLE') {
      setIsRevocableTrust(true);
      return;
    }

    setIsRevocableTrust(false);
  };

  return (
    <WizardStepWrapperTemplate
      submitConfirmation={!isRevocableTrust}
      submitConfirmationTitle={resource?.attr('trustRevocabilityConfirmationTitle')}
      submitConfirmationMessage={resource?.attr('trustRevocabilityConfirmationMessage')}
      submitConfirmationButtonLabel={resource?.attr('trustRevocabilityConfirmationPrimaryActionLabel')}
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={ContentWithContext}
      onChange={onChange}
      primaryActionLabel={resource.attr('primaryActionLabel') || undefined}
    />
  );
};

AccountOpeningTrustInformation.defaultProps = {
};

AccountOpeningTrustInformation.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default AccountOpeningTrustInformation;
